import { useEffect, useRef } from "react";

/**
 * Subscribe to server-sent bid events for a given leadId.
 * Pass leadId="all" to listen to all leads.
 * onBid(payload) is invoked when a new bid arrives.
 */
export function useBidStream(leadId, onBid) {
  const cbRef = useRef(onBid);
  useEffect(() => { cbRef.current = onBid; }, [onBid]);

  useEffect(() => {
    if (!leadId) return undefined;
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/events/bids/${leadId}`;
    const es = new EventSource(url, { withCredentials: true });

    const onMessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        cbRef.current?.(data);
      } catch {
        // ignore parse errors
      }
    };
    es.addEventListener("bid", onMessage);
    es.onerror = () => {
      // EventSource auto-reconnects; nothing to do here for now
    };
    return () => {
      es.removeEventListener("bid", onMessage);
      es.close();
    };
  }, [leadId]);
}
